// import * as types from './mutation-type'

export default {
  /**
   * define 'actions',handle change for async way. We can do more complex func in here.
   * @param {*} dispatch 'dispatch' has commit and state two params.
   * @param {*} payload variable of carrier
   */
}
